export default __webpack_public_path__ + "static/media/editor.4e3d484b.svg";